import ArticleLayout from "@/components/feature/ArticleLayout";

export default function TikTokArticle() {
  return <ArticleLayout slug="pandabuy-sheet-viral-tiktok" />;
}